import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as api from "Root/api/apiCommon";
const initState = {
    bannerData: {
        copy: "",
        code: "",
    },
};
export const fetchSeasonalPromotion = createAsyncThunk("profileSeasonalPromotion/fetchSeasonalPromotion", async (_) => {
    const promoBanner = await api.getPromotionalBanner();
    return { code: promoBanner.code, copy: promoBanner.copy };
});
const profileSeasonalPromotionSlice = createSlice({
    name: "profileSeasonalPromotion",
    initialState: initState,
    reducers: {
        updateBannerData(state, action) {
            state.bannerData = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSeasonalPromotion.fulfilled, (state, action) => {
            state.bannerData = action.payload;
        });
    },
});
export const { updateBannerData } = profileSeasonalPromotionSlice.actions;
export default profileSeasonalPromotionSlice.reducer;
